import { useRecordContext } from "react-admin";

export const WithOnlineHardware = ({ children }) => {
  const tower = useRecordContext();
  if (!tower) return null;
  if (!tower.hasOnlineHardware) return null;

  return children;
};
